import { defineMessages } from "@formatjs/intl";

export const messages = defineMessages({
  text: {
    id: "footer.text",
  },
});
